<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px; background-color: transparent">
        <div>
          <h4 class="title">捐助时间</h4>
          <el-date-picker
            v-model="journal_time"
            type="date"
            placeholder="选择时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div>
          <h4 class="title">捐助内容</h4>
          <el-input v-model="content" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">捐助金额</h4>
          <el-input
            v-model="money"
            placeholder="请输入"
            type="text"
            onkeyup="value=value.replace(/^(\d*\.?\d{0,2}).*/,'$1')"
          />
          <!-- oninput="if(isNaN(value)) { value = '' } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" -->
        </div>
        <div>
          <h4 class="title">捐助类型</h4>
          <el-select
            v-model="type"
            placeholder="请选择"
            @change="changeSelectType"
          >
            <el-option
              v-for="item in journalTypeOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div>
          <h4 class="title">备注</h4>
          <el-input v-model="remark" placeholder="请输入">></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

var thisIndex;
var thisUserName;
var thisType;
var thisInfo = {};

export default {
  data() {
    return {
      changVisible: false,

      title: "",

      journal_time: "",
      content: "",
      money: "",
      type: "",
      remark: "",
      clickLastTime: 0, //默认上一次点击时间为0
      // journalTypeOptions: Constant.journal_type_options, //捐助类型
      journalTypeOptions: ["捐赠", "赞助"], //捐助类型
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;

      if (thisInfo == undefined) {
        thisInfo = {};
        thisInfo.id = 0;
      }
      thisInfo.delete_time = 0;
      switch (thisType) {
        case "ais_journal":
          if (
            isEmpty(this.journal_time) ||
            isEmpty(this.content) ||
            isEmpty(this.type)
          ) {
            this.$message.error("请完善信息");
            return;
          }
          var timestamp1 = parseInt(new Date().getTime());
          var timeStr = this.journal_time.replace(/-/g, "/");
          var timestamp2 = new Date(timeStr).getTime();

          thisInfo.journal_time = this.journal_time;
          thisInfo.content = this.content;
          thisInfo.money = this.money;
          thisInfo.type = this.type;
          thisInfo.remark = this.remark;
          break;
      }
      this.changVisible = false;
      this.$emit("toSave", thisIndex, thisType, thisInfo);
    },
    //页面初始化时加载的事件
    show(index, userName, type, info) {
      this.cleanInput();
      this.changVisible = true;
      thisIndex = index;
      thisUserName = userName;
      thisType = type;
      thisInfo = info;
      switch (thisType) {
        case "ais_journal":
          if (thisInfo === undefined) {
            this.title = "新增 " + thisUserName + " 捐助信息";
            this.initJournal();
          } else {
            this.title = "编辑 " + thisUserName + " 捐助信息";
            this.editJournal(thisInfo);
          }
          break;
      }
    },
    // 清除输入框
    cleanInput() {
      this.journal_time = "";
      this.content = "";
      this.money = "";
      this.type = "";
      this.remark = "";
      this.changVisible = false;
    },
    // 添加捐助信息
    initJournal() {},
    // 编辑捐助信息
    editJournal(info) {
      this.initJournal();
      this.journal_time = info.journal_time;
      this.content = info.content;
      this.money = info.money;
      this.type = info.type;
      this.remark = info.remark;
    },
    changeSelectType(select) {
      console.log(select);
      this.type = select;
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addEditJournalDialog.vue